import React from 'react';
import {faImage} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {type CellContext, type RowData} from '@tanstack/react-table';
import {
	GenericImage,
	type GenericImageProps,
} from '@netx/core-components/GenericImage';
import {styled} from '@netx/core-components/Theme';

const GenericImageCellRoot = styled('div')(({theme}) => ({
	height: 39,
	width: 43,
	display: 'flex',
}));

export interface GenericImageCellProps<
	TData extends RowData,
> extends CellContext<
	TData,
	{
		src: string;
		alt: string;
	}
> {
	GenericImageProps?: Partial<GenericImageProps>;
}

export const GenericImageCellPrimitive = <TData extends RowData>({
	renderValue,
	GenericImageProps,
}: GenericImageCellProps<TData>) => {
	const src = renderValue();
	return (
		<GenericImageCellRoot>
			{src == null ? (
				<FontAwesomeIcon
					icon={faImage}
					style={{
						fontSize: 32,
						opacity: 0.25,
						margin: 'auto',
					}}
				/>
			) : (
				<GenericImage {...src} {...GenericImageProps} ref={undefined} />
			)}
		</GenericImageCellRoot>
	);
};

export const GenericImageCell = React.memo(GenericImageCellPrimitive) as <
	TData extends RowData,
>(
	props: GenericImageCellProps<TData>,
) => JSX.Element;

export default GenericImageCell;
